import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getStoredUser } from "../lib/auth";

function PublicOnlyRoute() {
  const user = getStoredUser();

  if (!user) {
    return <Outlet />;
  }

  return <Navigate to={user.role === "student" ? "/exam" : user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

export default PublicOnlyRoute;
